import { AUTHLOGIN, STAGE_02, UNI_INFO } from './action'

const loggedUser = {
    data: [],
}

export const loginReducer = (state = loggedUser, action) => {
    switch (action.type) {
        case AUTHLOGIN:
            return { ...state, LoginData: action.payload }
        default:
            return state
    }
}

export const uniInfoReducer = (state = loggedUser, action) => {
    switch (action.type) {
        case UNI_INFO:
            return { ...state, InfoData: action.payload }
        default:
            return state
    }
}

export const stageReducer = (state = loggedUser, action) => {
    switch (action.type) {
        case STAGE_02:
            return { ...state, stageData: action.payload }
        default:
            return state
    }
}
